var sound_control_rtlignore_default = {
  "root": "gZsf0",
  "sliderContainer": "ZW0Aa"
};
export {
  sound_control_rtlignore_default as default
};
//# sourceMappingURL=sound-control.rtlignore-scss.js.map
